import { subDays } from "date-fns";
import myAxios from "../../utils/axiosWrapper";
import getConfig from "../../conf/config";
import {
  ANALYTICS_FETCH,
  ANALYTICS_FETCH_FAILURE,
  ANALYTICS_FETCH_SUCCESS,
  ANALYTICS_INIT_FETCH_SUCCESS,
  ANALTYCS_LOADING,
} from "../actionTypes";
import { auth } from "../../conf/firebase";

// Fetch calls between start date and end date
export const getAnalyticsCalls = ({ start_date, end_date, dispatched = true }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ANALYTICS_FETCH, payload: { type: "calls" } });

      // Format dates using toISOString
      const formattedStartDate = new Date(start_date).toISOString();
      const formattedEndDate = new Date(end_date).toISOString();

      const base_url = `${getConfig().API_URL}/audio/api/v1/analytics/calls`;

      // Make Axios request to fetch calls data from the backend
      const response = await myAxios.get(
        `${base_url}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
      );
      const calls = response.data[0].data;
      if (dispatched) {
        // end
        dispatch({
          type: ANALYTICS_FETCH_SUCCESS,
          payload: { type: "calls", data: calls },
        });
      } else {
        return calls;
      }
    } catch (error) {
      console.log({ error });
      dispatch({ type: ANALYTICS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};

// Fetch calls between start date and end date
export const getAnalyticsCompanies = ({ start_date, end_date, dispatched = true }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ANALYTICS_FETCH, payload: { type: "companies" } });

      // Format dates using toISOString
      const formattedStartDate = new Date(start_date).toISOString();
      const formattedEndDate = new Date(end_date).toISOString();

      const base_url = `${getConfig().API_URL}/audio/api/v1/analytics/companies`;

      // Make Axios request to fetch calls data from the backend
      const response = await myAxios.get(
        `${base_url}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
      );
      const companies = response.data.data;
      if (dispatched) {
        // end
        dispatch({
          type: ANALYTICS_FETCH_SUCCESS,
          payload: { type: "companies", data: companies },
        });
      } else {
        return companies;
      }
    } catch (error) {
      console.log({ error });
      dispatch({ type: ANALYTICS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};

// Fetch calls between start date and end date
export const getAnalyticsOperators = ({ start_date, end_date, dispatched = true }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ANALYTICS_FETCH, payload: { type: "operators" } });

      // Format dates using toISOString
      const formattedStartDate = new Date(start_date).toISOString();
      const formattedEndDate = new Date(end_date).toISOString();

      const base_url = `${getConfig().API_URL}/audio/api/v1/analytics/operators`;

      // Make Axios request to fetch calls data from the backend
      const response = await myAxios.get(
        `${base_url}?start_date=${formattedStartDate}&end_date=${formattedEndDate}`
      );
      const { operators } = response.data[0];
      if (dispatched) {
        // end
        dispatch({
          type: ANALYTICS_FETCH_SUCCESS,
          payload: { type: "operators", data: operators },
        });
      } else {
        return operators;
      }
    } catch (error) {
      console.log({ error });
      dispatch({ type: ANALYTICS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};

// Fetch calls between start date and end date
export const getAnalyticsDepartments = ({ start_date, end_date, dispatched = true }) => {
  return async (dispatch) => {
    try {
      dispatch({ type: ANALYTICS_FETCH, payload: { type: "departments" } });
      // Format dates using toISOString
      const formattedStartDate = new Date(start_date).toISOString();
      const formattedEndDate = new Date(end_date).toISOString();

      const base_url = `${
        getConfig().API_URL
      }/audio/api/v1/analytics/departments?start_date=${formattedStartDate}&end_date=${formattedEndDate}`;

      // Make Axios request to fetch calls data from the backend
      const response = await myAxios.get(`${base_url}`);
      const departments = Object.values(response.data.data);
      if (dispatched) {
        // end
        dispatch({
          type: ANALYTICS_FETCH_SUCCESS,
          payload: { type: "departments", data: departments },
        });
      } else {
        return departments;
      }
    } catch (error) {
      console.log({ error });
      dispatch({ type: ANALYTICS_FETCH_FAILURE, payload: error.message });
      throw error;
    }
  };
};

// One request for the whole dashboard. The backend merges pre-aggregated day
// segments, so the department / direction filters are applied server-side at no
// extra query cost, and the payload keeps the shape of the four legacy
// /analytics endpoints it replaces.
export const initAnalytics = ({ start_date, end_date, department_id, direction = "all" }) => {
  return async (dispatch) => {
    const { currentUser } = auth;
    if (!currentUser || currentUser === null) {
      console.error("Not fetching analytics, user not authenticated");
      return;
    }

    const today = new Date();
    const start = start_date || subDays(today, today.getDay());
    const end = end_date || today;

    ["calls", "companies", "operators", "departments"].forEach((type) => {
      dispatch({ type: ANALYTICS_FETCH, payload: { type } });
    });

    try {
      const params = {
        start_date: new Date(start).toISOString(),
        end_date: new Date(end).toISOString(),
        direction,
      };
      if (department_id && department_id !== "all") {
        params.department_id = department_id;
      }

      const response = await myAxios.get(`${getConfig().API_URL}/audio/api/v1/analytics/overview`, {
        params,
      });
      const data = response?.data?.data || {};

      dispatch({
        type: ANALYTICS_INIT_FETCH_SUCCESS,
        payload: {
          calls: data.calls || {},
          companies: data.companies || {},
          calls_heatmap: data.calls_heatmap || null,
          // The bar chart consumes an array; the API keys departments by id.
          departments: Object.values(data.departments || {}),
          operators: data.operators || [],
          available_departments: data.available_departments || [],
        },
      });
    } catch (error) {
      console.error("Error fetching dashboard overview:", error);
      dispatch({ type: ANALYTICS_FETCH_FAILURE, payload: error.message });
    }
  };
};
